import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  heartlandItemColumns: [],
  heartlandCustomerColumns: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
